// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1QByi","disabled":"FileBtn_disabled__a3B_n","warn":"FileBtn_warn__DnIWY","fade":"FileBtn_fade__1iXdc"};